module.exports = __webpack_public_path__ + "prod/1.42.2/img/sempc-logo.49614351.png";